export enum SortingDirections {
    ASC = 'asc',
    DESC = 'desc',
}
